export { default as PaymentMethodFlatListWithButton } from './payment-method-flat-list-with-button';
